import { clamp, mapRange } from 'gsap/all';
import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onResizeBind = this.onResize.bind(this)

        // UI
        this.$el = this.el
        this.height = this.$el.offsetHeight;
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents();
        this.onResize();

        requestAnimationFrame(() => {
            this.onProgress(0)
        })
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener('resize', this.onResizeBind)
    }

    unbindEvents() {
        window.removeEventListener('resize', this.onResizeBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize() {
        this.height = this.$el.offsetHeight
    }

    onProgress(progress) {
        const scrolled = clamp(0, this.height, mapRange(0, 1, this.height, 0, progress))
        html.style.setProperty("--scrolled-header", `${scrolled}px`);
    }

    forceProgressStart() {
        html.style.setProperty("--scrolled-header", `${this.height}px`);
    }

    forceProgressEnd() {
        html.style.setProperty("--scrolled-header", `0px`);
    }
}
